var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickLhws(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#ED0A0A;}\n\t.st3{fill:#07A3E1;stroke-width:0;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WJyfAS.tif",
    className: "st1"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 773,
    height: 696,
    id: "Layer_1_1_",
    xlinkHref: "F63C2DB9BA8CF1CA.png",
    transform: "matrix(3.802644e-02 0 0 4.060250e-02 0.2771 1.1028)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.2,15.8C2.1,15,4,13.5,4.8,12.9c0.8-0.6,1.7-0.2,2.1,0.3c0.4,0.6,4.2,5.2,4.2,5.2S26.3,2.9,26.9,2.3 c1.5-1.6,3.6-1.5,1.7,1.7c-2.9,4.7-15.9,23.5-16.5,24.2c-0.6,0.7-1.1,1.8-2.4,0.4s-8.1-9.4-8.6-10.2C0.6,17.5-0.1,16.9,1.2,15.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickLhws);
export default __webpack_public_path__ + "static/media/tick-lhws.762b732ba02527ab675447b05926a043.svg";
export { ForwardRef as ReactComponent };